import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';

import MachineList from '../components/MachineList'
import Checkbox from 'material-ui/Checkbox';
import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import { Link } from 'react-router';
import PageLoading from '../components/PageLoading';
import {dateStr, dateAndTime} from '../utils/TimeFormatter';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';

import RefreshIndicator from 'material-ui/RefreshIndicator';

import RC from '../utils/ReactiveClock';
import { FlatButton } from 'material-ui';

//  serial_number_dib={machine.serial_number_dib}</li>

let pageStyle = {
  margin:"1em",
};

let headerStyle = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "20px",
  fontWeight: "400",
  height: "48px",
  lineHeight: "48px"
}

let lessEmphasis = {
  color: "gray",
  marginLeft: "2.5em"
}

const refresh = {
    display: 'inline-block',
    position: 'relative',
};

const resetCounter = [];

function lastReadings(machine) {
  if(!machine.last_measurements) return [];
  const interestingSensors = [
    {id_sensor:'FluidTank',name:uiMsg('MP_FLUID_TANK','Fluid tank'),unit:'dl'},
    {id_sensor:'H2O2',name:uiMsg('MP_H2O2','H2O2'),unit:'ppm'},
    {id_sensor:'H2O2_2',name:uiMsg('MP_H2O2_2','H2O2 (2)'),unit:'ppm'},
    {id_sensor:'H2O2RoomExternalSensor',name:uiMsg('MP_H2O2_EXT','H2O2 ext'),unit:'ppm'},
    {id_sensor:'RelativeHumidity',name:uiMsg('MP_HUMIDITY','Humidity'),unit:'%'},
    {id_sensor:'Temperature',name:uiMsg('MP_TEMP_ROOM','Temperature room'),unit:'deg C'},
    {id_sensor:'TemperatureInternalCompressor',name:uiMsg('MP_TEMP_COMPRESSOR','Temperature compressor'),unit:'deg C'}
  ];
  // Check if we have values for any of these :
  interestingSensors.forEach( is => {
    if(machine.last_measurements.has(is.id_sensor)) {
      let lm = machine.last_measurements.get(is.id_sensor);
      is.value = lm.value.toFixed(0);
      is.timestampStr = dateAndTime(lm.ts);
    }
  });
  // Return an array of only the filter that we had a recent value for
  return interestingSensors.filter ( is => is.value );
}

function statusMsg(machine) {
  if(machine.isJobRunning) {
    return uiMsg('MP_ONLINE_JOB_RUN',"Online, running job.");
  }
  let latestTS = latestTimestamp(machine.last_reading_ts, machine.last_heartbeat);
  if(!latestTS) return uiMsg('MP_UNKNOWN',"Unknown");
  let minutesSinceLastContact = (RC.reactiveTime - latestTS.getTime())/(1000*60);
  if (minutesSinceLastContact < 10) {
    return uiMsg('MP_ONLINE_NO_JOB',"Online. Not running job.");
  }
  return uiMsg('MP_OFFLINE_SINCE',"Offline since ",dateAndTime(latestTS));
}

function latestTimestamp(ts1, ts2) {
  if(ts1 && ts2) {
    if(ts1 > ts2) {
      return ts1;
    }
    return ts2;
  }
  if(ts1) {
    return ts1;
  }
  return ts2;
}

function showMachineConfiguration(machine) {
  return <Table>
    <TableBody displayRowCheckbox={false}>
      {machine.configuration.map( param =>
        <TableRow key={param.id_property}>
          <TableRowColumn>{param.id_property}: </TableRowColumn>
          <TableRowColumn>{param.display_value}</TableRowColumn>
        </TableRow>
      )}
    </TableBody>
  </Table>

}

export default
@observer class MachinePage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  gotoEditPage(machine) {
    return function() {
      this.context.router.push(
      `/machines/edit_machine_config/${encodeURI(machine.id)}`
      );
    }
  }

  gotoMachineAssignmentPage(machine) {
    return function() {
      this.context.router.push(
      `/machine_admin/assign/${encodeURI(machine.id)}`
      );
    }
  }
  gotoMachineHistoryPage(machine) {
    return function() {
      this.context.router.push(
        `/machines/machine/${encodeURI(machine.id)}/history`
      );
    }
  }

  gotoMachineContractsPage(machine) {
    return function() {
      this.context.router.push(
        `/machine_admin/contracts/${encodeURI(machine.id_customer)}/${encodeURI(machine.id)}`
        );
    }
  }

  activateSimCard(machine) {
    return function() {
      AppModelUtils.activateSimCard(machine);
    }
  }

  deactivateSimCard(machine) {
    return function() {
      AppModelUtils.deactivateSimCard(machine);
    }
  }
  configureSimCard(machine) {
    let self = this;
    
    return function(){
      AppModel.simCardForm.reset()
      AppModel.roamingStatus = null;
      AppModel.simCardForm.simCard = machine.simcard;    
      AppModel.simCardUsage = []; 
      
      self.context.router.push(`/simcards/simcard/${machine.simcard.phone}`);
    }
  }

  resetRunningTime(machine) {
    return function() {
      if(resetCounter.length == 0) {
        return;
      }
      AppModelUtils.resetRunningTime(machine, resetCounter.join(','));
    }
  }

  handleCheckboxChange = (propertyName) => (event, isChecked) => {
    const index = resetCounter.indexOf(propertyName);
    if(isChecked && index == -1) {
      resetCounter.push(propertyName);
    } else if (!isChecked && index > -1) {
      resetCounter.splice(index, 1);
    }
  }


  SIMCardUI(machine) {
    if(AppModel.fetchingSimActivationStatus) return <div>
      {uiMsg('MP_SIM_STATE_LOADING',"SIM state loading")}
      <RefreshIndicator size={25}
                        left={50}
                        top={5}
                        status="loading"
                        style={refresh}/>
    </div>;
    // If user is allowed to admin the SIM :
    let activated = machine.sim_activation_status && machine.sim_activation_status != 'reserved';
    if(AppModel.canAdminSIMs) return <span>
      <RaisedButton
        style={{marginLeft:'16px', marginTop:'16px'}}
        label={<span>{!activated ? uiMsg('MP_B_ACTIVATE_SIM',"Activate SIM Card") : uiMsg('MP_B_DEACTIVATE_SIM',"Deactivate SIM Card")}
        {AppModel.changingSIMCardActivationStatus ? <RefreshIndicator
            size={25}
            left={50}
            top={5}
            status="loading"
            style={refresh}
            />:null}</span>}
        disabled={AppModel.changingSIMCardActivationStatus}
        primary={true}
        onTouchTap={!activated ? this.activateSimCard(machine) : this.deactivateSimCard(machine)}
      />
      <FlatButton
        style={{marginLeft:'16px', marginTop:'16px'}}
        label={uiMsg('MP_B_CONFIGURE_SIM',"Configure SIM Card")}
        onTouchTap={this.configureSimCard(machine)}
      />
    </span>
      // User does not have SIM admin rights
      return  <span>
        {machine.sim_activation_status != 'activated' ?
          <span>{uiMsg('MP_SIM_NOT_ACTIVATED',"SIM card not activated")}</span>
          : // SIM is activated
          <span>{uiMsg('MP_SIM_ACTIVATED',"SIM card activated")}</span>
        }
      </span>;
  }

  render() {
    let machine = AppModel.currentMachine;
    let contract = machine.contract || {};
    let lastReadingsToDisplay = lastReadings(machine);
    console.log("Sensor display values:", lastReadingsToDisplay.map(s => ({ id: s.id_sensor, name: s.name, value: s.value })));

    return (
      <div style={pageStyle}>
        <PageLoading loading={machine.loading}>
          <h2 style={headerStyle}>{uiMsg('MP_H_MACHINE',"Machine")}</h2>
          <Table>
            <TableBody displayRowCheckbox={false}>
            <TableRow> <TableRowColumn>{uiMsg('ID',"Id")}:</TableRowColumn> <TableRowColumn>{machine.id}</TableRowColumn></TableRow>
            <TableRow> <TableRowColumn>{uiMsg('STATUS',"Status")}:</TableRowColumn> <TableRowColumn>{statusMsg(machine)}</TableRowColumn></TableRow>
            <TableRow> <TableRowColumn>{uiMsg('NAME',"Name")}:</TableRowColumn> <TableRowColumn>{machine.name}</TableRowColumn></TableRow>
            <TableRow> <TableRowColumn>{uiMsg('MODEL',"Model")}:</TableRowColumn> <TableRowColumn>{machine.model || ''}</TableRowColumn></TableRow>
            <TableRow> <TableRowColumn>{uiMsg('SOFTWARE',"Software")}:</TableRowColumn> <TableRowColumn>{machine.software_version} ({machine.micro_controller_software_version})</TableRowColumn></TableRow>
            {lastReadingsToDisplay.map( lrd =>
              <TableRow key={lrd.id_sensor}> <TableRowColumn>{lrd.name}</TableRowColumn> <TableRowColumn>{lrd.value} {lrd.unit} <span style={lessEmphasis}>{lrd.timestampStr}</span></TableRowColumn></TableRow>
            )}
            </TableBody>
          </Table>
          {AppModel.canAllocateMachines?
            <RaisedButton
              style={{marginLeft:'16px'}}
              label={uiMsg('MP_B_ASSIGN_MACHINE',"Assign machine to customer")}
              primary={true}
              onTouchTap={this.gotoMachineAssignmentPage(machine).bind(this)} />
            :null
          }
          {AppModel.isSystemAdmin ?
            <RaisedButton
              style={{marginLeft:'16px'}}
              label={uiMsg('MP_B_MACHINE_HISTORY',"Machine History")}
              primary={false}
              onTouchTap={this.gotoMachineHistoryPage(machine).bind(this)}
            />
          : null}
          <div style={{height:"1em"}}></div>
          <h2 style={headerStyle}>{uiMsg('MP_H_CONTRACT',"Contract")}</h2>
          <Table>
            <TableBody displayRowCheckbox={false}>
            <TableRow> <TableRowColumn>{uiMsg('NC_CONTRACT_TYPE',"Contract Type")}: </TableRowColumn>
                      <TableRowColumn>{uiMsg(this.contractTypeUIKey(contract.type))}</TableRowColumn></TableRow>
            <TableRow> <TableRowColumn>{uiMsg('START_DATE',"Start date")}: </TableRowColumn>
                      <TableRowColumn>{dateStr(contract.delivery)}</TableRowColumn></TableRow>
            <TableRow> <TableRowColumn>{uiMsg('END_DATE',"End date")}: </TableRowColumn>
                      <TableRowColumn>{dateStr(contract.end_of_contract)}</TableRowColumn></TableRow>
            <TableRow> <TableRowColumn>{uiMsg('MP_SUPPORT_PAID_TILL',"Support paid till")}: </TableRowColumn>
                      <TableRowColumn>{dateStr(contract.support_paid_till)}</TableRowColumn></TableRow>
            </TableBody>
          </Table>
          {AppModel.canAdminCustomers?
            <RaisedButton
              style={{marginLeft:'16px'}}
              label={uiMsg('MP_B_MANAGE_CONTRACTS',"Manage contracts")}
              primary={true}
              onTouchTap={this.gotoMachineContractsPage(machine).bind(this)} />
            :null
          }
          <div style={{height:"1em"}}></div>
          <h2 style={headerStyle}>{uiMsg('MP_MACHINE_CONFIG',"Machine configuration")}</h2>
          {!AppModel.uiSession.MachinePage_showMachineDetails ?
            <RaisedButton
              style={{marginLeft:'16px', marginTop:'16px'}}
              label={uiMsg('MP_B_SHOW_CONFIG',"Show machine configuration")}
              primary={false}
              onTouchTap={ ()=>{AppModel.uiSession.MachinePage_showMachineDetails=true} } />
            :null
          }
          {AppModel.uiSession.MachinePage_showMachineDetails ? showMachineConfiguration(machine) : null}
          {AppModel.canRegisterMachines ?
            <RaisedButton
              style={{marginLeft:'16px'}}
              label={uiMsg('MP_B_EDIT_CONFIG',"Edit configuration")}
              primary={true}
              onTouchTap={this.gotoEditPage(machine).bind(this)} />
            :null
          }
          {AppModel.uiSession.MachinePage_showMachineDetails ?
            <RaisedButton
              style={{marginLeft:'16px'}}
              label={uiMsg('MP_B_HIDE_CONFIG',"Hide configuration")}
              primary={false}
              onTouchTap={ ()=>{AppModel.uiSession.MachinePage_showMachineDetails=false} } />
            :null
          }
          <div style={{height:"1em"}}></div>
          <h2 style={headerStyle}>{uiMsg('MP_SIM_CARD_STATUS',"SIM Card")}</h2>
          { machine.hasValidSimCard ? this.SIMCardUI(machine)
            : /* No valid sim card */
            <span>{uiMsg('MP_SIM_NOT_INSTALLED',"SIM card not installed")}</span>
          }
          <div style={{height:"1em"}}></div>
          
          {AppModel.isSystemAdmin ?
            <div>
              <h2 style={headerStyle}>{uiMsg('MP_MACHINE_COMPONENT_STATUS',"Component Status")}</h2>
              
              <Table selectable={false} width="500px">
                <TableHeader displaySelectAll={false} adjustForCheckbox={false}> 
                    <TableHeaderColumn align="left">{uiMsg('MP_MACHINE_COMPONENT',"Component")}</TableHeaderColumn>
                    <TableHeaderColumn align="left">{uiMsg('MP_MACHINE_RUNNING_TIME',"Running Time (hh:mm)")}</TableHeaderColumn>
                    <TableHeaderColumn align="left">{uiMsg('MP_MACHINE_LAST_RESET',"Last Reset")}</TableHeaderColumn>
                    <TableHeaderColumn align="left">{uiMsg('MP_MACHINE_SELECT_RESET',"Select to reset")}</TableHeaderColumn>
                </TableHeader>  
                <TableBody displayRowCheckbox={false}>
                  <TableRow>
                    <TableRowColumn>{uiMsg('MP_COMPRESSOR', "Compressor")}</TableRowColumn>
                    <TableRowColumn>{machine.running_time_compressor ? machine.running_time_compressor : ""}</TableRowColumn>
                    <TableRowColumn>{machine.last_reset_timestamp_compressor ? machine.last_reset_timestamp_compressor : ""}</TableRowColumn>
                    <TableRowColumn align="center">
                      <Checkbox onCheck={this.handleCheckboxChange("Compressor")}/>
                     </TableRowColumn>
                  </TableRow>
                  <TableRow>
                    <TableRowColumn>{uiMsg('MP_LIQUID_PUMP', "Liquid Pump")}</TableRowColumn>
                    <TableRowColumn>{machine.running_time_liquid_pump ? machine.running_time_liquid_pump : ""}</TableRowColumn>
                    <TableRowColumn>{machine.last_reset_timestamp_liquid_pump ? machine.last_reset_timestamp_liquid_pump : ""}</TableRowColumn>
                    <TableRowColumn align="center">
                      <Checkbox onCheck={this.handleCheckboxChange("LiquidPump")}/>
                     </TableRowColumn>
                  </TableRow>
                  <TableRow>
                    <TableRowColumn>{uiMsg('MP_AIR_FILTER', "Air Filter")}</TableRowColumn>
                    <TableRowColumn>{machine.running_time_air_filter ? machine.running_time_air_filter : ""}</TableRowColumn>
                    <TableRowColumn>{machine.last_reset_timestamp_air_filter ? machine.last_reset_timestamp_air_filter : ""}</TableRowColumn>
                    <TableRowColumn align="center">
                      <Checkbox onCheck={this.handleCheckboxChange("AirFilter")}/>
                     </TableRowColumn>
                  </TableRow>
                </TableBody>
              </Table>
              <RaisedButton
                      style={{marginLeft:'16px', marginTop:'8px'}}
                      label={uiMsg('MP_RESET_RUNNIG_TIME',"Reset")}
                      onTouchTap={this.resetRunningTime(machine)}
               />
              <div style={{height:"1em"}}></div>
             </div>
          : null}
          
        </PageLoading>
      </div>
    );
  }

  contractTypeUIKey(type) {
    if (!type) {
      return 'MP_UNKNOWN';
    }
    if( type == 'Buy') {
      return 'NC_MACHINE_BUY';
    } else if (type == 'Hire') {
      return 'NC_MACHINE_RENTAL';
    } else if (type == 'Support') {
      return 'NC_MACHINE_SUPPORT';
    } else if (type == 'Prevent') {
      return 'NC_PREVENT';
    } else if (type == 'Pilot') {
      return 'NC_PILOT';
    } else if (type == 'Prevent Owner') {
      return 'NC_PREVENT_OWNER';
    }
  }
};



/** WEBPACK FOOTER **
 ** ./src/pages/MachinePage.jsx
 **/